export default "__VITE_ASSET__DyLT4FHl__"